export const AllTags = ({ tag }) => {
    return (
        <div>
            <button className="btn btn-outline btn-primary rounded-full no-animation">{tag}</button>
        </div>
    )
}